import { Globe, Users, MessageCircle, Phone as PhoneIcon, Sparkles, ExternalLink } from "lucide-react";

// Central definition — used by SourceBadge, filters, and stats.
export const LEAD_SOURCE_META = {
  angi:      { label: "Angi",      classes: "bg-orange-100 text-orange-800 border-orange-300", Icon: ExternalLink },
  thumbtack: { label: "Thumbtack", classes: "bg-cyan-100 text-cyan-800 border-cyan-300",       Icon: ExternalLink },
  google:    { label: "Google",    classes: "bg-blue-100 text-blue-800 border-blue-300",       Icon: Globe },
  yelp:     { label: "Yelp",     classes: "bg-rose-100 text-rose-800 border-rose-300",       Icon: Sparkles },
  facebook: { label: "Facebook", classes: "bg-indigo-100 text-indigo-800 border-indigo-300", Icon: Users },
  website:  { label: "Website",  classes: "bg-emerald-100 text-emerald-800 border-emerald-300", Icon: Globe },
  direct:   { label: "Direct",   classes: "bg-gray-100 text-gray-800 border-gray-300",       Icon: Users },
  referral: { label: "Referral", classes: "bg-amber-100 text-amber-800 border-amber-300",    Icon: Users },
  phone:    { label: "Phone",    classes: "bg-sky-100 text-sky-800 border-sky-300",          Icon: PhoneIcon },
  other:    { label: "Other",    classes: "bg-gray-100 text-gray-700 border-gray-300",       Icon: MessageCircle },
};

export const LEAD_SOURCES = Object.keys(LEAD_SOURCE_META);

export default function SourceBadge({ source, className = "" }) {
  const key = (source || "direct").toLowerCase();
  const meta = LEAD_SOURCE_META[key] || LEAD_SOURCE_META.other;
  const Icon = meta.Icon;
  return (
    <span
      data-testid={`source-badge-${key}`}
      className={`inline-flex items-center gap-1 text-[9px] font-extrabold uppercase tracking-[0.14em] px-2 py-0.5 rounded-full border ${meta.classes} ${className}`}
      title={`Lead source: ${meta.label}`}
    >
      <Icon className="w-2.5 h-2.5" /> {meta.label}
    </span>
  );
}
